appSocial.controller('errorPage', [
    '$scope', '$state', '$stateParams', '$timeout', 'SocialLocaleService',
    function ($scope, $state, $stateParams, $timeout, SocialLocaleService) {

        class ErrorPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;

                this.modal = {
                    isError: true,
                    textTitle: 'Something went wrong',
                    textContent: 'Please contact support',
                    actionText: 'Back',
                    back: 'root.app.assets',
                    state: false
                }

                $timeout(() => {
                    this.modal.state = true;
                })

                const error = this.parseError($stateParams);
                if (error) {
                    this.modal = _.merge(this.modal, error);
                }
            }

            parseError(param) {
                let error;
                try {
                    error = JSON.parse(param.err);
                } catch (e) {
                    console.log('Failed to parse state params: ', param)
                }
                return error;
            }
        }

        return new ErrorPage()
    }]);

